import * as yup from 'yup';
import {
  addOptionalNullableToSchema,
  optionalNullableNameSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';

export const generalSchema = yup.object().shape({
  name: requiredNameSchema,
  organization_id: yup.string().required(requiredErrorMessage),
  partner_id: yup.string().required(requiredErrorMessage),
  operator_id: yup.string().required(requiredErrorMessage),

  google_places_id: addOptionalNullableToSchema(yup.string()),
  street: requiredNameSchema,
  suite: optionalNullableNameSchema,
  city: requiredNameSchema,
  state: stateSchema.required(requiredErrorMessage),
  zip_code: zipSchema.required(requiredErrorMessage),
  county: optionalNullableNameSchema,
  phone_number: addOptionalNullableToSchema(phoneSchema),
  fax_number: addOptionalNullableToSchema(phoneSchema),
});
